import { caseInsensitiveSort } from '@/lib/sort';
import type { Campus, Entity, Ministry, MinistryTypeKey } from './types';
import type { OrgStore } from '.';
import { useMemo } from 'react';

function campusList(campuses: Record<string, Campus>) {
  return Object.values(campuses).sort(caseInsensitiveSort('data.name'));
}

function activeCampusList(campuses: Record<string, Campus>) {
  const list = campusList(campuses);

  return list.filter((item) => !item.data.archived);
}

function entityList(entities: Record<string, Entity>) {
  return Object.values(entities).sort(caseInsensitiveSort('data.name'));
}

export function useComputed(context: OrgStore) {
  return {
    campusesList: useMemo(
      () => activeCampusList(context.state.campuses.data),
      [context.state.campuses.data],
    ),
    ministriesLookup: useMemo(
      () => makeMinistriesLookup(context.state.ministries.data),
      [context.state.ministries.data],
    ),
    entityList: useMemo(
      () => entityList(context.state.entities.data),
      [context.state.entities.data],
    ),
  };
}

export type Computed = ReturnType<typeof useComputed>;

function makeMinistriesLookup(items: Ministry[]) {
  const lookup: Record<string, Record<MinistryTypeKey, Ministry>> = {};
  for (const item of items) {
    let entries = lookup[item.data.campus_id];
    if (!entries) {
      entries = {} as Record<MinistryTypeKey, Ministry>;
      lookup[item.data.campus_id] = entries;
    }

    entries[item.data.type] = item;
  }

  return lookup;
}
